/** Linha de comissão lida de planilha/CSV (leitura local no navegador). */
export type FinanceiroComissaoRow = {
  pasta: string
  arquivo: string
  codigoCorretor: string
  nomeCorretor: string
  cpfCnpj: string
  apolice: string
  numeroSub: string
  modulo: string
  estipulante: string
  subEstipulante: string
  fatura: string
  competencia: string
  valorApropriado: number | null
  tipoComissao: string
  parcelaInicial: string
  numeroGrupoCobertura: string
  valorBase: number | null
  percentualComissao: number | null
  valorComissao: number | null
  dataEmissao: string
  dataApropriacao: string
  valorPremioBruto: number | null
  valorPremioTarifario: number | null
  dataMovimento: string
  dataAgendamento: string
  dataPagamento: string
  dataPagamentoEfetivo: string
  statusRecibo: string
  nrCobranca: string
}

export type FinanceiroComissaoFileStatus = 'pendente' | 'lendo' | 'ok' | 'erro'

export type FinanceiroComissaoFileProgress = {
  id: string
  pasta: string
  fileName: string
  relativePath: string
  status: FinanceiroComissaoFileStatus
  rowCount: number
  error?: string
}

export type FinanceiroComissaoSubpasta = {
  name: string
  files: File[]
  fileCount: number
}

/** Subpasta descoberta na pasta raiz (ainda sem carregar arquivos). */
export type FinanceiroComissaoSubpastaInfo = {
  name: string
  year: string | null
}

export type FinanceiroComissaoRootListing = {
  rootName: string
  years: string[]
  subfolders: FinanceiroComissaoSubpastaInfo[]
}

/** Registro de pasta já processada no banco. */
export type FinanceiroComissoesIcatuPasta = {
  id: string
  folder_name: string
  year: string | null
  root_folder_name: string | null
  files_ok: number
  files_error: number
  row_count: number
  processed_by: string | null
  processed_at: string
  created_at: string
  updated_at: string
}

export type FinanceiroComissoesIcatuLinha = {
  id: string
  folder_id: string
  folder_name: string
  file_name: string
  // Spreadsheet fields (Portuguese)
  codigo_corretor: string
  nome_corretor: string
  cpf_cnpj: string
  apolice: string
  numero_sub: string
  modulo: string
  estipulante: string
  sub_estipulante: string
  fatura: string
  competencia: string
  valor_apropriado: number | null
  tipo_comissao: string
  parcela_inicial: string
  numero_grupo_cobertura: string
  valor_base: number | null
  percentual_comissao: number | null
  valor_comissao: number | null
  data_emissao: string
  data_apropriacao: string
  valor_premio_bruto: number | null
  valor_premio_tarifario: number | null
  data_movimento: string
  data_agendamento: string
  data_pagamento: string
  data_pagamento_efetivo: string
  status_recibo: string
  nr_cobranca: string
  uploaded_by: string | null
  created_at: string
  updated_at: string
}

export type FinanceiroComissaoSaveFolderStatus =
  | 'pendente'
  | 'gravando'
  | 'ok'
  | 'erro'
  | 'ja_processada'

/** Andamento da gravação de uma pasta no banco. */
export type FinanceiroComissaoSaveFolderProgress = {
  pasta: string
  status: FinanceiroComissaoSaveFolderStatus
  totalRows: number
  savedRows: number
  error?: string
}

export type SaveComissoesIcatuProgressEvent = {
  pastaNome: string
  savedRows: number
  totalRows: number
}

export type SaveComissoesIcatuInput = {
  pastaNome: string
  ano: string | null
  rootFolderName: string | null
  rows: FinanceiroComissaoRow[]
  arquivosOk: number
  arquivosErro: number
  userId: string | null
  onProgress?: (event: SaveComissoesIcatuProgressEvent) => void
}

export class FinanceiroPastaJaProcessadaError extends Error {
  readonly pastaNome: string

  constructor(pastaNome: string) {
    super(`A pasta "${pastaNome}" já foi processada.`)
    this.name = 'FinanceiroPastaJaProcessadaError'
    this.pastaNome = pastaNome
  }
}
